module.exports = __webpack_public_path__ + "img/kolase3.61a74ce0.jpg";